import { Component, Fragment, h, Host, Prop } from '@stencil/core';
import { ButtonAppearance, ButtonControlValues } from '../types';

@Component({
  tag: 'rentware-button-controls',
  styleUrl: 'style.sass',
  shadow: false,
})
export class RentwareCartButton {
  @Prop() controlValues: ButtonControlValues;
  @Prop() appearance: ButtonAppearance;
  container: HTMLElement;

  componentDidLoad() {
    setTimeout(
      () => (this.container.style.opacity = '1'),
      200, //need to be exact as global transition
    );
  }

  componentWillUpdate() {
    if (this.controlValues.currentQuantity > this.controlValues.maxQuantity) {
      this.controlValues.currentQuantity = this.controlValues.maxQuantity;
    }

    if (this.controlValues.currentQuantity < this.controlValues.minQuantity) {
      this.controlValues.currentQuantity = this.controlValues.minQuantity;
    }
  }

  onIncrease = () => {
    if (this.controlValues.currentQuantity < this.controlValues.maxQuantity) {
      this.controlValues.onChange(this.controlValues.currentQuantity + 1);
    }
  };

  onDecrease = () => {
    if (this.controlValues.currentQuantity > this.controlValues.minQuantity) {
      this.controlValues.onChange(this.controlValues.currentQuantity - 1);
    }
  };

  handleCorrectKey = e => {
    if (!Number.isInteger(+e.key)) {
      e.preventDefault();
    }
  };

  handleChange = e => {
    if (e.target.value < this.controlValues.minQuantity) {
      e.target.value = this.controlValues.minQuantity;
      this.controlValues.onChange(this.controlValues.minQuantity);
    } else if (e.target.value > this.controlValues.maxQuantity) {
      e.target.value = this.controlValues.maxQuantity;
      this.controlValues.onChange(this.controlValues.maxQuantity);
    } else {
      this.controlValues.onChange(e.target.value);
    }
  };

  get minusButtonStyle() {
    const buttonStyle = (this.controlValues.currentQuantity > this.controlValues.minQuantity && 'Icons ' + this.appearance.style + 'ButtonControlActive ') || 'Icons IconDisabled';
    return this.appearance.style + 'ButtonControl ' + buttonStyle;
  }

  get plusButtonStyle() {
    const buttonStyle = (this.controlValues.currentQuantity < this.controlValues.maxQuantity && 'Icons ' + this.appearance.style + 'ButtonControlActive ') || 'Icons IconDisabled ';
    return this.appearance.style + 'ButtonControl ' + buttonStyle;
  }

  get hasRange() {
    return this.controlValues.minQuantity !== this.controlValues.maxQuantity;
  }

  get inputClass() {
    return this.appearance.style + 'ButtonControl ButtonInput';
  }

  get dividerClass() {
    return this.appearance.style + 'Divider Divider';
  }

  render() {
    return (
      <Host class="ControlsContainer" ref={el => (this.container = el as HTMLElement)}>
        {(this.hasRange && (
          <Fragment>
            <div class="IconsContainer">
              <div class={this.minusButtonStyle} onClick={this.onDecrease} tabindex="0">
                <svg width="8" height="2" viewBox="0 0 8 2" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 1H4H7" stroke-linecap="round" />
                </svg>
              </div>

              <div class={this.plusButtonStyle} onClick={this.onIncrease} tabindex="0">
                <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M1 3.95569H4M7 3.95569H4M4 3.95569V1M4 3.95569V7" stroke-linecap="round" />
                </svg>
              </div>
            </div>

            <div class={this.dividerClass} />

            <input
              type="number"
              class={this.inputClass}
              maxlength="3"
              value={this.controlValues.currentQuantity}
              onKeyPress={e => this.handleCorrectKey(e)}
              onChange={e => this.handleChange(e)}
            />
          </Fragment>
        )) || (
          <Fragment>
            <div class="Spacer" />

            <div class="InfoNumber">{this.controlValues.currentQuantity}</div>
          </Fragment>
        )}
      </Host>
    );
  }
}
